module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(!_vm.start_ia) ? _c('div', {
    staticClass: "flex bg-theme-1 p-2 rounded mb-4 cursor-pointer w-10 justify-center hidden",
    on: {
      "click": function($event) {
        return _vm.IAreport()
      }
    }
  }, [_c('app-icon', {
    staticClass: "w-5 h-5 text-white",
    attrs: {
      "name": "rocket"
    }
  })], 1) : _c('div', {
    staticClass: "flex bg-theme-1 p-2 rounded gap-2 mb-4 cursor-pointer w-full"
  }, [(_vm.icon_ia) ? _c('app-icon', {
    staticClass: "w-5 h-5 text-white",
    attrs: {
      "name": "rocket"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "text-white w-full",
    domProps: {
      "innerHTML": _vm._s(_vm.simpleMarkdownToHTML(_vm.message))
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.loadCalendar) ? _c('app-kalendar', {
    attrs: {
      "configuration": _vm.calendar_settings,
      "events": _vm.calendars
    },
    on: {
      "update:events": function($event) {
        _vm.calendars = $event
      },
      "click": _vm.handleEventClick
    },
    scopedSlots: _vm._u([{
      key: "created-card",
      fn: function(ref) {
        var event_information = ref.event_information;

        return _c('div', {
          staticClass: "details-card cursor-pointer",
          on: {
            "click": function($event) {
              return _vm.handleEventClick(event_information)
            }
          }
        }, [_c('h4', {
          staticClass: "appointment-description"
        }, [_vm._v("\n          " + _vm._s(event_information.data.title) + "\n        ")]), _vm._v(" "), _c('span', {
          staticClass: "time"
        }, [_vm._v(_vm._s(_vm._f("formatToHours")(event_information.start_time)) + " -\n          " + _vm._s(_vm._f("formatToHours")(event_information.end_time)))]), _vm._v(" "), (_vm.id == _vm.user.slug) ? _c('button', {
          staticClass: "remove",
          on: {
            "click": function($event) {
              return _vm.removeEventKalendar(event_information)
            }
          }
        }, [_c('app-icon', {
          staticClass: "text-white w-4 h-4",
          attrs: {
            "name": "trash"
          }
        })], 1) : _vm._e()])
      }
    }, {
      key: "creating-card",
      fn: function(ref) {
        var event_information = ref.event_information;

        return _c('div', {}, [_c('h4', {
          staticClass: "appointment-title",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n          Nuevo Evento\n        ")]), _vm._v(" "), _c('span', {
          staticClass: "time"
        }, [_vm._v("\n          " + _vm._s(_vm._f("formatToHours")(event_information.start_time)) + " -\n          " + _vm._s(_vm._f("formatToHours")(event_information.end_time)) + "\n        ")])])
      }
    }, {
      key: "popup-form",
      fn: function(ref) {
        var popup_information = ref.popup_information;

        return _c('div', {
          staticStyle: {
            "display": "flex",
            "flex-direction": "column"
          }
        }, [_c('h4', {
          staticStyle: {
            "margin-bottom": "10px"
          }
        }, [_vm._v("Nuevo Evento")]), _vm._v(" "), _c('form', {
          on: {
            "submit": function($event) {
              $event.preventDefault();
              return _vm.addEvent(popup_information)
            }
          }
        }, [_c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.new_appointment['description']),
            expression: "new_appointment['description']"
          }],
          attrs: {
            "type": "text",
            "placeholder": "Titulo",
            "rows": "2",
            "required": ""
          },
          domProps: {
            "value": (_vm.new_appointment['description'])
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.new_appointment, 'description', $event.target.value)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "buttons"
        }, [_c('button', {
          staticClass: "cancel",
          on: {
            "click": function($event) {
              return _vm.closePopups()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
          attrs: {
            "type": "submit",
            "disabled": _vm.buttonIsLoading
          }
        }, [_vm._v("Guardar")])])])])
      }
    }], null, false, 1533033317)
  }) : _vm._e(), _vm._v(" "), (_vm.event_current) ? _c('div', {
    staticClass: "fixed bg-white w-56 bottom-0 left-0 h-40 p-2 rounded"
  }, [_c('div', {
    staticClass: "flex flex-col justify-center items-center border border-theme-1 p-2 h-32 mt-2"
  }, [_c('p', {
    staticClass: "text-theme-1 mb-2"
  }, [_vm._v("\n          " + _vm._s(_vm._f("limit100")(_vm.event_current.data.title)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex gap-3"
  }, [_c('button', {
    staticClass: "border border-theme-1 text-theme-1 rounded py-1 px-2 text-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.event_current = null
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), (_vm.id == _vm.user.slug) ? _c('button', {
    staticClass: "bg-theme-1 text-white rounded py-1 px-2 text-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeEventList(_vm.event_current.data)
      }
    }
  }, [_vm._v("\n            Eliminar\n          ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('h2', {
    staticClass: "mb-2 font-bold text-lg"
  }, [_vm._v("\n        Lista de Eventos (" + _vm._s(_vm.filteredCalendars.length) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 inline-flex gap-2"
  }, [_c('div', {
    staticClass: "py-2"
  }, [_vm._v("Filtrar por fecha:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-56 border flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.filter.date) ? _c('div', {
    staticClass: "bg-theme-1 p-2 rounded w-10 h-10 cursor-pointer hover:bg-theme-6",
    on: {
      "click": function($event) {
        _vm.filter.date = null
      }
    }
  }, [_c('app-icon', {
    staticClass: "text-white w-4 h-4",
    attrs: {
      "name": "trash"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filteredCalendars), function(calendar, index) {
    return _c('div', {
      key: calendar.id,
      staticClass: "bg-white p-2 rounded mb-2 flex px-5"
    }, [(_vm.editIndex === index) ? _c('div', {
      staticClass: "w-2/6"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_calendar.title),
        expression: "current_calendar.title"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_calendar.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_calendar, "title", $event.target.value)
        }
      }
    })]) : _c('div', {
      staticClass: "w-2/6"
    }, [_vm._v(_vm._s(calendar.title))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4"
    }, [_vm._v(_vm._s(calendar.from.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4"
    }, [_vm._v(_vm._s(_vm._f("formatToHours")(calendar.from)))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4"
    }, [_vm._v(_vm._s(_vm._f("formatToHours")(calendar.to)))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4 text-center"
    }, [(_vm.editIndex === index) ? _c('button', {
      staticClass: "bg-green-400 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.updateItem()
        }
      }
    }, [_vm._v("\n            Guardar\n          ")]) : _c('button', {
      staticClass: "bg-theme-1 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(index, calendar)
        }
      }
    }, [_vm._v("\n            Editar\n          ")]), _vm._v(" "), (_vm.id == _vm.user.slug) ? _c('button', {
      staticClass: "bg-red-600 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEventList(calendar)
        }
      }
    }, [_vm._v("\n            Eliminar\n          ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('h2', {
    staticClass: "font-medium mr-auto fixed bottom-0 bg-theme-1 text-white border-1 border-white py-2 px-4 rounded-t-lg z-10"
  }, [_vm._v("\n      Calendario "), (_vm.user_calendar) ? _c('span', [_vm._v(" - " + _vm._s(_vm.user_calendar.name))]) : _vm._e()])], 1) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-689f2d6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/calendar/CalendarUser.vue
// module id = 450
// module chunks = 1